export default __webpack_public_path__ + "static/media/Note.6947697c.svg";